export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
// Role ids (match api/src/helpers/roles.js)
export const ROLES = Object.freeze({ CELL_LEADER: 1, ADMIN: 2, SUPER_ADMIN: 3 });

// A user can hold several roles. Falls back to the legacy single `role` field
// for sessions stored before multi-role support.
export function rolesOf(user) {
  if (!user) return [];
  if (Array.isArray(user.roles) && user.roles.length > 0) return user.roles.map(Number);
  return user.role != null ? [Number(user.role)] : [];
}

export function hasRole(user, ...roles) {
  const userRoles = rolesOf(user);
  return roles.some((r) => userRoles.includes(r));
}
